import { useEffect, useRef } from 'react'

import { logger } from '@/utils'

const log = logger.child({
  file: 'src/hooks/useTabUnfocus.tsx',
})
export const useTabUnfocus = (callback: () => void) => {
  const isUnloading = useRef(false)
  useEffect(() => {
    const controller = new AbortController()
    const { signal } = controller

    const handlePageHide = () => {
      isUnloading.current = true
    }

    const handleVisibilityChange = () => {
      if (isUnloading.current) {
        log.debug('skipping token refresh due to navigation/refresh')
        return
      }
      if (document.hidden) {
        callback()
      }
    }

    window.addEventListener('pagehide', handlePageHide, { signal })

    document.addEventListener('visibilitychange', handleVisibilityChange, {
      signal,
    })

    return () => {
      controller.abort()
    }
  }, [callback])
}
